import { render, staticRenderFns } from "./ProductPanel.vue?vue&type=template&id=0d087528&scoped=true"
import script from "./ProductPanel.vue?vue&type=script&lang=js"
export * from "./ProductPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d087528",
  null
  
)

export default component.exports